module.exports = (envs) => {
  const { env, urlEnv } = getUrlEnvironment(window.location.origin, envs.REACT_APP_ORIGIN_PROD, envs.REACT_APP_ORIGIN_LOCAL);
  const country = getCountry();
  return {
    publicPath: envs.REACT_APP_PUBLIC_PATH || '/web',
    env,
    encryption: env === 'prod' || env === 'qa',
    applicationName: envs.REACT_APP_NAME || 'help-center-web',
    contextService: envs.REACT_APP_CONTEXT_SERVICE || 'BACK_OFFICE',
    helpCenterBffURL: `${urlEnv}${envs.REACT_APP_HELP_CENTER_BFF_URL}`,
    contextCountry: country,
    googleReCaptcha: envs.REACT_APP_RECAPTCHA_KEY || '6LfobzggAAAAALA7gtlK5twrH9Iw1AlahKX-fmtJ',
    googleTagManager: env === 'prod' ? envs.REACT_APP_GOOGLE_TAG_MANAGER : undefined,
    widgetScript: process.env.REACT_APP_WIDGET_SCRIPT || 'https://apollo-public.loyal.ink/survey/ZnBheS90ZXN0LWZwYXk=.js',
    widgetEvent: process.env.REACT_APP_WIDGET_EVENT || 'prodfpaytest',
    widgetTag: process.env.REACT_APP_WIDGET_TAG || 'apollo-ZnBheS90ZXN0LWZwYXk=',
  };
};

const getCountry = () => {
  const url = window.location.href;
  if (url.includes('.com.co') || url.includes('https://co-')) {
    return 'co';
  }
  if (url.includes('.pe') || url.includes('https://pe-')) {
    return 'pe';
  }
  return 'cl';
};

const getUrlEnvironment = (currentURL, urlProd, urlLocal) => {
  if (currentURL.includes('localhost') || currentURL.includes('127.0.0.1')) {
    return {
      env: 'local',
      urlEnv: urlLocal || 'https://int.fpaynegocios.com',
    };
  }
  if (currentURL.includes('int')) {
    return {
      env: 'int',
      urlEnv: currentURL,
    };
  }
  if (currentURL.includes('qa')) {
    return {
      env: 'qa',
      urlEnv: currentURL,
    };
  }
  return {
    env: 'prod',
    urlEnv: urlProd || 'https://backoffice.fpaynegocios.com',
  };
};
